"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PublicCelebrations = void 0;
var CardName_1 = require("../../CardName");
var CardType_1 = require("../CardType");
var CardRequirements_1 = require("../CardRequirements");
var Card_1 = require("../Card");
var PublicCelebrations = (function (_super) {
    __extends(PublicCelebrations, _super);
    function PublicCelebrations() {
        return _super.call(this, {
            cost: 8,
            tags: [],
            name: CardName_1.CardName.PUBLIC_CELEBRATIONS,
            cardType: CardType_1.CardType.EVENT,
            requirements: CardRequirements_1.CardRequirements.builder(function (b) { return b.chairman(); }),
            metadata: {
                description: 'Requires that you are Chairman.',
                cardNumber: 'T10',
                victoryPoints: 2,
            },
        }) || this;
    }
    PublicCelebrations.prototype.play = function () {
        return undefined;
    };
    PublicCelebrations.prototype.getVictoryPoints = function () {
        return 2;
    };
    return PublicCelebrations;
}(Card_1.Card));
exports.PublicCelebrations = PublicCelebrations;
